module.exports = __webpack_public_path__ + "static/media/surgicalKit.b33e3ed5.png";